const faqs = [
  {
    q: '99视频是否需要注册或付费？',
    a: '完全不需要。99视频是一个免费的视频聚合平台，无需注册账号，无需付费订阅，打开网站即可直接观看香蕉视频、红桃视频、91视频、蜜桃视频等多个平台的影视内容，真正做到即开即看。',
  },
  {
    q: '99视频的影视资源从哪里来？',
    a: '99视频聚合了香蕉视频、红桃视频、91视频、蜜桃视频等主流视频平台的公开资源，通过技术手段将分散在各平台的影视内容整合到一处，方便用户一站式浏览与观看，无需在不同平台之间来回跳转。',
  },
  {
    q: '播放视频时出现卡顿怎么办？',
    a: '99视频采用多线路智能切换技术，如果当前播放源出现卡顿，可以尝试刷新页面或等待系统自动切换备用线路。同时建议检查您的网络连接状态，确保带宽充足。我们的技术团队持续优化播放体验，大部分用户都能获得流畅的高清观看效果。',
  },
  {
    q: '99视频支持哪些设备观看？',
    a: '99视频全面支持桌面端（Windows/Mac）、平板和手机浏览器访问。网站采用响应式设计，自动适配不同屏幕尺寸。同时提供移动端下载入口，Android和iOS用户均可获得专属优化的观影体验。支持Chrome、Safari、Edge等主流浏览器。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            关于99视频聚合平台的常见疑问解答，帮助您更好地使用本站服务
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden cursor-pointer"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                <h3 className="font-semibold text-foreground-950 text-sm md:text-base pr-4">
                  {faq.q}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-background-200 flex items-center justify-center group-open:bg-primary-50 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-500 group-open:rotate-180 transition-all text-sm"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}